import src from "IMAGE";
export default { src, width: 2362, height: 708, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANUlEQVR42i3JsREAEBBFwWtGpgBGAYYZAbrTgQ50973ggo3WJB1cTBREZDQE83zYWOioGEgfBO81jy+BXaUAAAAASUVORK5CYII="};
